import {Injectable} from '@angular/core';
import {IRecuperationListeDonneesMetier} from '@app/core/interfaces';
import {Observable} from 'rxjs';
import {Autowired} from '@angular-ru/autowired';
import {DocumentTableListeRestApiService} from './document-table.liste.rest-api.service';

@Injectable({providedIn: 'root'})
export class DocumentTableListeMetierService implements IRecuperationListeDonneesMetier {
  @Autowired() restApi: DocumentTableListeRestApiService;

  requeteRecuperationListeDonnees(data: any, args?: any): Observable<any> | Promise<any> | any {
    return this.restApi.requeteRecuperationListeDonnees(data, args);
  }
}
